import { defineStore } from 'pinia'

export const useServiceStore = defineStore('serviceStore', () => {
  // Define the services array
  const servicesArray = ref([])

  // Add a new service
  const addService = (newService) => {
    servicesArray.value.push({
      ...newService,
      id: servicesArray.value.length + 1,
    })
  }
  // Edit a service
  const editService = (updatedService) => {
    const index =
      servicesArray.value.findIndex(service=>
        service.id === updatedService.id)
    if (index !== -1) {
      servicesArray.value[index] = updatedService
    }
  }

  // Calculate the final price of a service after applying discounts
  const calculateServicePrice = (price, discountType, discountValue) => {

    let finalPrice = Number(price || 0)

    if (discountType === 'solid' && discountValue) {
      finalPrice -= Number(discountValue)
    } else if (discountType === 'percent' && discountValue) {
      finalPrice = finalPrice * (1 - (Number(discountValue) / 100))
    }

    return Math.max(0, finalPrice)
  }

  // Delete a service
  const deleteService = (serviceId) => {
    servicesArray.value =
      servicesArray.value.filter(service=>
        service.id !== serviceId)
  }
  // ****************** //
  async function fetchServices() {
    try {
      const response = await $backend(`/calendar/services`, {
        method: 'GET',
      })

      let employeeServices = Object.values(response.data)
      let flatServicesArray = []
      employeeServices.forEach(employee => {
        // console.log('e', employee)
        let services = Object.values(employee.services)
        //console.log('s', typeof services, services)
        services.map((service) => {
          //console.log('x', service)
          flatServicesArray.push({
            employeeEkey: employee.employeeEkey,
            employeeTitle: employee.employeeTitle,
            ...service,
          })
        })
      })

      servicesArray.value = flatServicesArray


      return servicesArray.value
    } catch (error) {
      console.error(error)
    }

    return {}
  }

  return {
    servicesArray,
    addService,
    editService,
    deleteService,
    fetchServices,
    calculateServicePrice,
  }
})
